import { disableFragmentWarnings } from 'graphql-tag';

disableFragmentWarnings();

export * from './typeDefs';
export * from './resolvers';